const translations = {
    en: {
        logo_text: 'MiZaem',
        site_name: 'MiZaem.ru',
        logo_description: '',
        footer_text: '',
        sign_in_through: '',

        register: '',
        enter: '',
        exit: '',
        next: '',
        back: '',
        close: '',
        confirm: '',

        change_password: '',
        settings_saved: '',
        password_saved: '',

        my_offers: '',
        profile: '',
        offers: '',
        users: '',
        deals: '',
        notification_settings: '',
        user_cabinet: '',
        forgot_password: '',
        divider_or: '',

        phone_number: '',
        email: '',
        password: '',
        confirm_password: '',

        errors: {
            check_correct: '',
            phone_number_not_valid: '',
            wrong_auth_params: '',
            wrong_login_or_password: '',
            email_not_valid: '',
            phone_already_registered: '',
            email_already_registered: '',
            server_error: '',
            wrong_code: '',
        },

        page_not_found: '',
        return_to_main_page: '',

        password_restoration: '',
        your_email: '',
        code_from_mail: '',
        code_from_sms: '',
        restore_password: '',
        send_code: '',
        send: '',

        get_percent_to_approve_chance_phone_and_email: '',
        get_percent_to_approve_chance_phone: '',
        confirm_your_phone: '',
        we_will_send_code_to_phone: '',
        last_step_left: '',
        request_for_getting_money: '',
        approvement_chance: '',
        we_sent_mail_to_your_email: '',
        we_sent_mail_to_your_email_confirm: '',
        best_offers_for_you: '',

        contact_info: '',
        phone_confirmation: '',
        email_confirmation: '',
        registration_check: '',

        sum: '',
        rating: '',
        loan_sum: '',
        up_to_x_currency: '',
        loan_period: '',
        up_to_x_days: '',
        percentage_rate: '',
        from_x_percent_in_day: '',
        from_x_percent: '',
        get_money: '',
        currency: '',
        days: '',

        name: '',
        surname: '',
        second_name: '',

        confirmed: '',
        not_confirmed: '',

        email_not_confirmed: '',
        phone_not_confirmed: '',

        we_recommend_to_use_all_offers: '',

        exception: {
            VerificationCodeAlreadySentException: '',
            UserNotFoundException: '',
            UserAlreadyRegisteredException: ""
        },
        terms_of_use_title: '',
        personal_terms_title: '',
        terms_of_use: '',
        offer_terms: ''

    },
};
export default translations;
